import { createClient } from '@supabase/supabase-js';

const isTest = process.env.NODE_ENV === 'test';
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

let supabase;
if (isTest) {
  // Minimal stub matching used surface area for tests
  supabase = {
    auth: {
      getSession: async () => ({ data: { session: null } }),
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
      signUp: async () => ({ data: { user: null }, error: null }),
      signInWithPassword: async () => ({ user: null, error: null }),
      signOut: async () => ({ error: null }),
      signInWithOAuth: async () => ({ data: {}, error: null }),
      resetPasswordForEmail: async () => ({ data: {}, error: null }),
    },
  };
} else {
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables. Please check your .env file.');
  }
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      debug: false, // Disable debug logging
      storage: window.localStorage,
      storageKey: 'supabase.auth.token',
    },
    logger: {
      level: 'error', // Only log errors
      custom: (level, message, data) => {
        if (level === 'error') {
          console.error(`[SUPABASE ERROR]`, message, data);
        }
      },
    },
  });
}

// Avoid runtime-only helpers in test to prevent window access issues
if (!isTest) {
  // Set up auth state change listener
  supabase.auth.onAuthStateChange((event, session) => {
    // Auth state changes are handled by AuthContext
    // No logging needed here to keep console clean
  });
}

export { supabase };